function dd84FindVariant(variants, selectedOptions){
  for (const v of variants){
    if (!v || !v.options) continue;
    let ok = true;
    for (let i=0;i<selectedOptions.length;i++){
      if ((v.options[i] || '') !== (selectedOptions[i] || '')) { ok = false; break; }
    }
    if (ok) return v;
  }
  return null;
}
function dd84Money(cents, currency){
  try{ return new Intl.NumberFormat(undefined,{style:'currency',currency:currency}).format(cents/100); }
  catch(e){ return (cents/100).toFixed(2); }
}
function dd84SwapImage(form, variant){
  const img = form.closest('.dd84-product')?.querySelector('[data-product-image]');
  if (!img) return;
  if (variant && variant.image && variant.image.src){
    img.src = variant.image.src;
    if (variant.image.alt) img.alt = variant.image.alt;
  }
}

document.addEventListener('change', (e)=>{
  const target = e.target;
  const form = target && target.closest ? target.closest('[data-product-form]') : null;
  if (!form) return;
  if (!target.matches('[data-option-index]')) return;

  const variantsEl = form.querySelector('[data-variants-json]');
  const variants = JSON.parse((variantsEl && variantsEl.textContent) ? variantsEl.textContent : '[]');
  const currency = form.getAttribute('data-currency') || 'USD';

  const optionSelects = form.querySelectorAll('[data-option-index]');
  const selected = [];
  optionSelects.forEach(sel => { selected[Number(sel.getAttribute('data-option-index'))] = sel.value; });

  const match = dd84FindVariant(variants, selected);
  const idInput = form.querySelector('input[name="id"]');
  const priceEl = form.querySelector('[data-price]');
  const atcBtn = form.querySelector('[data-atc]');
  const soldEl = form.querySelector('[data-soldout]');

  if (match){
    if (idInput) idInput.value = match.id;
    if (priceEl) priceEl.textContent = dd84Money(match.price, currency);
    const available = match.available === true;
    if (atcBtn){
      atcBtn.disabled = !available;
      atcBtn.textContent = available ? 'Add to cart' : 'Sold out';
    }
    if (soldEl) soldEl.style.display = available ? 'none' : 'block';

    // NEW: swap image on variant change (usually tied to Color)
    dd84SwapImage(form, match);
  }
});

document.addEventListener('DOMContentLoaded', ()=>{
  document.querySelectorAll('[data-product-form]').forEach(form=>{
    const firstSel = form.querySelector('[data-option-index]');
    if (firstSel) firstSel.dispatchEvent(new Event('change', {bubbles:true}));
  });
});
